import { RedbubbleLayout } from '@redbubble/next/app';
import { RBLayoutProps, WithLayout } from '@redbubble/next/types';
import { NextPage } from 'next/types';
import { useEngageTextMessaging } from '../../hooks/useEngageTextMessaging';
import { CategoryPage } from './components/CategoryPage';
import SearchResultsPage from './SearchResultsPage';
import type { ShopPageProps } from './types';

const ShopPage: WithLayout<NextPage<ShopPageProps>> = (props) => {
  if (props.pageType === 'category') {
    return <CategoryPage {...props} />;
  }

  return <SearchResultsPage {...props} />;
};

const ShopPageLayout = (props: RBLayoutProps) => {
  const engagingPlaceholderMessages = useEngageTextMessaging();

  return RedbubbleLayout({ ...props, engagingPlaceholderMessages });
};

ShopPage.layout = ShopPageLayout;

export default ShopPage;
